import clone from 'clone';

export const SET_SEARCH_MACHINES = 'SET_SEARCH_MACHINES';

export function setSearchMachines(value) {
    return { type: SET_SEARCH_MACHINES, value: clone(value) };
}
